import masonry from 'vue-next-masonry'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(masonry, undefined)
})
